import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

import { useTranslation } from "react-i18next";
//import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

import ReCAPTCHA from "react-google-recaptcha";


// reactstrap components
import {
    Card, CardHeader,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
    Label,
    Button
} from "reactstrap";

import Swal from "sweetalert2";

import StepUser from "views/pages/register/steps/RegisterStepUser.js";
import StepCompany from "views/pages/register/steps/RegisterStepCompany.js";
import StepPwd from "views/pages/register/steps/RegisterStepPwd.js";
import StepEmail from "views/pages/register/steps/RegisterStepEmail.js";

import * as commonFunc from 'scripts/common';

function Register(props) {
    const { t } = useTranslation();

    React.useEffect(() => {
        document.body.classList.toggle("register-page");
        return function cleanup() {
            document.body.classList.toggle("register-page");
        };
    });

    const recaptchaRef = React.useRef();
    const [signupUrlInfos] = useSearchParams();
    var urlEmail = signupUrlInfos?.get("email");

    const [urlValidation, setUrlValidation] = React.useState(false);
    const [currStep, setCurrStep] = React.useState("1");
    const [step1, setStep1] = React.useState({});
    const [step2, setStep2] = React.useState({});
    const [step3, setStep3] = React.useState({});
    const [step4, setStep4] = React.useState({});
    const [triggerAnimate, setTriggerAnimate] = React.useState(true);

    const [currentSubscription, setCurrentSubscription] = React.useState();

    const navigate = useNavigate();

    const getFingerprint = async () => {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        return result.visitorId;
    };


    //Gestion arrivé extSignup
    if (urlEmail && !urlValidation) {
        setUrlValidation(true);
        Swal.fire({
            title: t("log_checkInfos"),
            didOpen: () => { Swal.showLoading() }
        });

        commonFunc.postMethod("../api/ValidateEmail", { email: urlEmail }).then((response) => {
            Swal.close();
            var result = response.data;
            if (result.isSuccess) {
                if (result.result && urlEmail === result.result.email) {
                    setStep1({ email: result.result.email || urlEmail, title: "M", provider: result.result.extLink });//TEMP title tant que pas saisie
                    setStep2({ pwd: "External"/*, pwdConfirm: "", pwdScore: 99*/ });
                    setStep3({ name: result.result.name, firstName: result.result.firstName, country: "France" });

                    setCurrStep("4");
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: t("gal_error"),
                        html: t("register_errorValidEmail"),
                    });
                }
            }
            else if (result.errorCode === 400 || result.errorCode === 500) {
                Swal.fire({
                    icon: 'error',
                    title: t("gal_error"),
                    html: result.errorMessage,
                });
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: t("gal_error"),
                    html: result.errorMessage,
                });
            }
        });
    }

    React.useEffect(() => {
        Swal.fire({
            title: "Récupération en cours...   ",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
        var productId = parseInt(signupUrlInfos.get("productId")) || 10;//10 >> Correspond à la version trial
        if (urlEmail) productId = parseInt(localStorage.getItem("signUpProductId")) || productId;
        commonFunc.getMethod("../api/GetProductOffers", { id: productId }).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();

                    if (response.data.result && response.data.result.length) {
                        setCurrentSubscription(response.data.result[0]);
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Erreur",
                        html: "Erreur lors de la récupération de l'offre sélectionné :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Erreur lors de la récupération de l'offre sélectionné"
                });
            }
        });

    }, []);

    function prevStep(targetStep) {
        setTriggerAnimate(false);
        setTimeout(() => {
            setCurrStep(targetStep);
        }, 900);
    }

    function updateStep(data, step) {
        setTriggerAnimate(false);
        setTimeout(async () => {
            switch (step) {
                case 1:
                    setStep1(data);
                    setCurrStep("2");
                    break;
                case 2:
                    setStep2(data);
                    setCurrStep("3");
                    break;
                case 3:
                    setStep3(data);
                    setCurrStep("4");
                    break;
                case 4:
                    setStep4(data);

                    data.recaptcha = await recaptchaRef.current.executeAsync();
                    getFingerprint().then((fingerprint) => {
                        data.deviceId = fingerprint;
                        data.productId = parseInt(signupUrlInfos.get("productId")) || 10;//-1 //10 >> Correspond à la version trial
                        triggerSubmit(Object.assign({}, step1, step2, step3, data));
                    });
                    break;
                default: break;
            }
        }, 900);
    }

    async function triggerSubmit(data) {
        Swal.fire({
            title: "Enregistrement de votre inscription...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var userAccountReq = data;
        await commonFunc.postMethod("../api/RegisterSubscription", userAccountReq).then((response) => {
            if (response.data && response.data.isSuccess) {
                // Récupération du token JWT depuis le localStorage
                // const token = localStorage.getItem('token');

                // Inclusion du token JWT dans les en-têtes de la requête
                const token = response.data.result.accessToken;
                localStorage.setItem('token', token);
                axios.defaults.headers['Authorization'] = `Bearer ${token}`;

                Swal.close();
                Swal.fire({
                    title: "Récupération en cours...   ",
                    didOpen: () => { Swal.showLoading() },
                });

                commonFunc.getMethod("../api/GetUser", null).then((response) => {
                    if (response.data) {
                        if (response.data.isSuccess) {
                            Swal.close();
                            props.setLoggedStatus(true);

                            if (!(currentSubscription.isSpecial && currentSubscription.categ === "TRIAL")) {
                                navigate("/ConfirmSubscription?productId=" + currentSubscription.idProduct);
                            }
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur lors de la récupération de l'utilisateur :<br>" + response.data.errorMessage
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Erreur",
                            html: "Erreur lors de la récupération de l'utilisateur"
                        });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Echec d'enregistrement :<br>" + response.data.errorMessage
                }).then(() => {
                    window.location.reload();
                });
                //grecaptcha.reset();
                //expiredCallback();
            }
        });
    }
    console.debug(Object.assign({}, step1, step2, step3, step4));
    console.debug(currentSubscription);

    var renderingInfos = (currentSubscription ? <>
            <div className="info-area info-horizontal mt-4">
                <div className="icon icon-primary d-none">
                    <i className="fa fa-tv" />
                </div>
                <div className={`description subscription-${currentSubscription.themeClass}`}>
                    <h5 className="info-title">{currentSubscription.name}&nbsp;{currentSubscription.description}</h5>
                    <h6 className="info-title">{currentSubscription.productCycle ? currentSubscription.productCycle.name : ""}</h6>
                    <Card style={{ maxWidth: "200px" }}>
                        <img
                            className="img-fluid subscription-img"
                            alt="..."
                            src={currentSubscription.avatar || require("assets/img/bg/logooskala.png")}
                            style={{ borderRadius: "12px" }}
                        />
                    </Card>
                    <p className="description">{currentSubscription.descriptionAlt}</p>
                    <div className="">
                        <Button className={`btn-round btn-self-magnify ${currentSubscription.themeClass} ms-3`} color="primary" onClick={() => {
                            var win = window.open(currentSubscription.url, "_blank");
                            win.focus();
                        }}>{t("register_checkOffers")}</Button>
                    </div>
                </div>
            </div>
            
            <div>
            <a href="https://play.google.com/store/apps/details?id=com.softena.oskalacore"><img src="https://www.oskala.com/assets/fr_badge_web_generic.png" width="128" className="img-fluid" alt="google_play" /></a>
            <div className="mb-1 text-info">
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star-half"></i>
                <span className="fa-solid text-secondary2">4.5</span>
                </div>
            <small className="text-muted d-none"><br />Google Play et le logo Google Play sont des marques de Google LLC.</small>
            </div>
        </>
        : <div className="">
            <h5 className="info-title">Oskala Core</h5>
            <div>
                <a href="https://play.google.com/store/apps/details?id=com.softena.oskalacore"><img src="https://www.oskala.com/assets/fr_badge_web_generic.png" width="128" className="img-fluid" alt="google_play" /></a>
                <div className="mb-1 text-info">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star-half"></i>
                    <span className="fa-solid text-secondary2">4.5</span>
                </div>
                <small className="text-muted d-none"><br />Google Play et le logo Google Play sont des marques de Google LLC.</small>
            </div>

            <div className="info-area info-horizontal mt-5 d-none">
                <div className="icon icon-primary">
                    <i className="fa fa-tv" />
                </div>
                <div className="description">
                    <h5 className="info-title">{t("register_title1")}</h5>
                    <p className="description">{t("register_text1")}</p>
                </div>
            </div>
            <div className="info-area info-horizontal d-none">
                <div className="icon icon-primary">
                    <i className="fa-brands fa-html5" />
                </div>
                <div className="description">
                    <h5 className="info-title">{t("register_title2")}</h5>
                    <p className="description">{t("register_text2")}</p>
                </div>
            </div>
            <div className="info-area info-horizontal d-none">
                <div className="icon icon-info">
                    <i className="fa fa-atom" />
                </div>
                <div className="description">
                    <h5 className="info-title">{t("register_title3")}</h5>
                    <p className="description">{t("register_text3")}</p>
                </div>
            </div>
        </div>);


    return (
        <div className="register-page">
            <Container className="mt-0">
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey="6LfJ5KcpAAAAAFwA7DM-smKf4sfJmq6FHDF-Zt9q"
                />
                <Row className="align-items-center">
                    <Col className="ms-auto d-none d-lg-block" lg="5">
                        {renderingInfos}
                    </Col>
                    <Col className={`mx-auto ${triggerAnimate ? "animate__animated animate__bounceInDown" : "animate__animated animate__bounceOut"}`} lg="5" md="12">
                        <Card className={`card-signup text-center`}>
                            <CardHeader className="mb-2 pt-2" style={{ backgroundColor:"#00000008", borderBottom: "1px solid rgba(0, 0, 0, .125)" }}><h3 className="mb-1">{t("register_reg")}</h3></CardHeader>
                            <Row>
                                <div className="col-8 mx-auto d-flex justify-content-between">
                                    <div className={`${currStep === "1" ? "bg-step-progress text-light" : "border border-step-progress text-step-progress"} rounded-circle rond align-items-center d-flex justify-content-center fw-bold`}><span className="sizing">1</span></div>

                                    <div className={`${currStep === "2" ? "bg-step-progress text-light" : "border border-step-progress text-step-progress"} rounded-circle rond align-items-center d-flex justify-content-center fw-bold`}><span className="sizing">2</span></div>

                                    <div className={`${currStep === "3" ? "bg-step-progress text-light" : "border border-step-progress text-step-progress"} rounded-circle rond align-items-center d-flex justify-content-center fw-bold`}><span className="sizing">3</span></div>

                                    <div className={`${currStep === "4" ? "bg-step-progress text-light" : "border border-step-progress text-step-progress"} rounded-circle rond align-items-center d-flex justify-content-center fw-bold`}><span className="sizing">4</span></div>
                                </div>
                            </Row>
                            <TabContent activeTab={currStep}>
                                <TabPane tabId="1">
                                    <StepEmail shouldRender={currStep === "1"} email={step1?.email} defaultData={step1} productId={currentSubscription?.idProduct} updateStep={(data) => updateStep(data, 1)} triggerAnimate={() => setTriggerAnimate(true)} />
                                </TabPane>
                                <TabPane tabId="2">
                                    <StepPwd shouldRender={currStep === "2"} email={step1?.email} defaultData={step2} isFrench={step1.country === "France"} updateStep={(data) => updateStep(data, 2)} prevStep={() => { prevStep("1") }} triggerAnimate={() => setTriggerAnimate(true)} />
                                </TabPane>
                                <TabPane tabId="3">
                                    <StepUser shouldRender={currStep === "3"} email={step1?.email} defaultData={step3} isFrench={step1.country === "France"} updateStep={(data) => updateStep(data, 3)} prevStep={() => { prevStep("2") }} triggerAnimate={() => setTriggerAnimate(true)} />
                                </TabPane>
                                <TabPane tabId="4">
                                    <StepCompany shouldRender={currStep === "4"} extSignup={urlEmail ? true : false} email={step1?.email} defaultData={step4} isFrench={step1.country === "France"} updateStep={(data) => updateStep(data, 4)} prevStep={() => { prevStep("3") }} triggerAnimate={() => setTriggerAnimate(true)} />
                                </TabPane>
                            </TabContent>
                            <Label className="text-mandatory text-end fw-bold pe-3 h6 mb-2">{t("register_reqFields")}</Label>
                            {currStep === "1" ? <Link className="link-secondary text-start ms-2 mb-2" to="/login">{t("register_accessLogin")}</Link> : ""}
                        </Card>
                    </Col>
                    <Col className="d-block d-lg-none" md="12">
                        {renderingInfos}
                    </Col>
                </Row>
            </Container>
            <div
                className="full-page-background"
                style={{
                    backgroundImage: `url(${require("assets/img/bg/backblur22.jpg")})`,
                }}
            />
        </div>
    );
}

export default Register;
